<div class="page-container">
    <header class="page-header">
        <div class="header-left">
            <h1>Users</h1>
            <p class="subtitle">Manage system access</p>
        </div>
        <div class="header-actions">
            <!-- Logout moved to Navbar -->
            <button *ngIf="isAdmin" (click)="createNew()" class="btn-secondary">
                <i class="fa fa-plus"></i> New User
            </button>
        </div>
    </header>

    <div class="table-container" *ngIf="!isLoading">
        <table class="premium-table">
            <thead>
                <tr>
                    <th>User</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Status</th>
                    <th *ngIf="isAdmin" class="text-right">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let user of users">
                    <td data-label="User">
                        <div class="user-cell">
                            <div class="avatar">{{ (user.username || user.firstName)?.charAt(0) | uppercase }}</div>
                            <div class="info">
                                <span class="name">{{ user.username }}</span>
                            </div>
                        </div>
                    </td>
                    <td data-label="Email">{{ user.email }}</td>
                    <td data-label="Role">
                        <span class="role-desc" *ngIf="user.role">{{ user.role }}</span>
                        <span class="text-muted italic" *ngIf="!user.role">No Role</span>
                    </td>
                    <td data-label="Status">
                        <span class="status-badge status-{{user.status}}">{{ getStatusLabel(user.status) }}</span>
                    </td>
                    <td *ngIf="isAdmin" class="text-right" data-label="Actions">
                        <button (click)="editUser(user.id)" class="btn-icon" title="Edit User">
                            <i class="fa fa-edit"></i>
                        </button>
                        <button (click)="deleteUser(user.id)" class="btn-icon delete" title="Delete">
                            <i class="fa fa-trash"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div *ngIf="isLoading" class="loading-state">
        <div class="spinner"></div>
        <p>Loading users...</p>
    </div>


</div>